export default __webpack_public_path__ + "static/media/loader.4bf0245f.svg";